import type { Stroke } from '../../types';
import type { Shape } from '../diagram/shapes/Shape';
import type { Connector } from '../diagram/shapes/Connector';
import type { TextElement } from '../diagram/shapes/TextElement';
import type { DrawShape } from '../draw/shapes';

export class UnifiedStore {
  // Draw mode elements
  strokes: Stroke[] = [];
  drawShapes: DrawShape[] = [];

  // Diagram mode elements
  shapes: Shape[] = [];
  connectors: Connector[] = [];

  // Shared elements
  textElements: TextElement[] = [];

  selectedElements: Set<string> = new Set();

  // Shared viewport state (pan/zoom/inverted persist across mode switches; grid/snap are per-mode)
  viewport: { scale: number; panX: number; panY: number; inverted: boolean } | null = null;
}
